import _extends from "@babel/runtime/helpers/esm/extends";
import React from 'react';
import List from '../List';

function SidebarList(props) {
  return /*#__PURE__*/React.createElement(List, _extends({
    as: "div",
    marginBottom: 2,
    border: true,
    borderColor: "separatorSecondary",
    shrink: 0,
    divider: true,
    dividerColor: "separatorSecondary"
  }, props));
}

export default SidebarList;